/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {Component, useState} from 'react';
import "../../CSS/DataModal.css";
import FullLoader from "../Loader/FullLoader";

function UpdateTagsModal(props) {
    const { show, updateLoading, appliedTags, unappliedTags, removeList, applyList, handleApply, handleRemove, onUpdateTags, onClick, checked } = props;
    const [loading, setLoading] = useState(false);
    
    const onCancelClick = () => {
        
    }

    let loader = updateLoading ?
        <FullLoader/>
        : <div>{null}</div>

    let modalContent = !show ? 
        <div>{null}</div> 
        : <div>
            <div className="modal" style={{ display: show ? (updateLoading ? "none": "block") : "none" }}>
                <div className="modal-wrapper"
                     style={{
                         transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
                         opacity: show ? '1' : '0'
                     }}>

                    <div className="modal-header">
                        <h3>Asset Tags</h3>
                        <span className="close-modal-btn" onClick={e => { onClick(e); onCancelClick(); }}>×</span>
                    </div>

                    <div className="modal-body text-left">
                        <div className="white-container width-100p border-top border-left">
                            <h6 className="sectionTitle" id="tabelLabel1">Currently Applied Tags</h6>
                            <div className="table-container-2">
                                <table className='table table-striped table-bordered table-sm table-hover' aria-labelledby="tabelLabel" >
                                    <thead>
                                    <tr >
                                        <th className={"width-340"}>Name</th>
                                        <th className={"width-75"}>Remove</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {appliedTags.map((ttTag, index) =>
                                        <tr key={ttTag.id} data={index}>
                                            <td>{ttTag.name}</td>
                                            <td className={"text-center"}>
                                                <input type="checkbox" id="rc" value={ttTag.id} className="px-1 width-50" checked={checked} onChange={handleRemove} />
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div className="white-container width-100p border-top border-left" >
                            <h6 className="sectionTitle" id="tabelLabel1">Available Tags to Apply</h6>
                            <div className="table-container-2">
                                <table className='table table-striped table-bordered table-sm table-hover' aria-labelledby="tabelLabel" >
                                    <thead>
                                    <tr >
                                        <th className={"width-340"}>Name</th>
                                        <th className={"width-75 text-center"}>Apply</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {unappliedTags.map((ttTag, index) =>
                                        <tr key={ttTag.id} data={index}>
                                            <td>{ttTag.name}</td>
                                            <td className={"text-center"}>
                                                <input type="checkbox" id="ac" value={ttTag.id} className="px-1 width-50" checked={checked} onChange={handleApply} />
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    <div className="modal-footer">
                        <button className="secondary-btn btn-small" onClick={e => { onClick(e); onCancelClick(); }}>Cancel</button>
                        <button className="primary-btn btn-small" onClick={onUpdateTags}>Update Tags</button>
                    </div>

                </div>

            </div>
            {loader}
        </div>;
    
    return (
        <div>{modalContent}</div>
    )
}
export default UpdateTagsModal;